// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adjustWidthReview[data-v-32cf20c5] {\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  margin-left: 51px;\n  margin-top: -30px;\n}\n.customCardConatiner[data-v-32cf20c5] {\n  margin-bottom: 8px !important;\n  border-radius: 4px;\n  border: 1px solid #e6e6e6;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n", ""]);
// Exports
module.exports = exports;
